import React from 'react';
import PropTypes from 'prop-types';
import AdvertiserCampaignSelect from './AdvertiserCampaignSelect';
import AffiliateSelect from './AffiliateSelect';

export default class DestinationSelect extends React.Component {
  constructor(props) {
    super(props);
    this.destinationCampaign = props.virtualLineMover.destinationCampaign;
  }

  render() {
    return (
      <div>
        <AdvertiserCampaignSelect
          uniqueNameField={this.destinationCampaign.advertiserCampaignId}
          destinationCampaign={this.destinationCampaign}
          changeListener={this.updateAdvertiserCampaignId.bind(this)}
          errorMessage={this.applyErrorToSelect("advertiser")}
        />
        { this.destinationCampaign.requiresAffiliate() &&
          <AffiliateSelect
            uniqueNameField={this.destinationCampaign.affiliateId}
            destinationCampaign={this.destinationCampaign}
            nameLabel={this.destinationCampaign.affiliateLabel}
            advertiserCampaignId={this.destinationCampaign.advertiserCampaignId}
            key={this.destinationCampaign.advertiserCampaignId}
            changeListener={this.updateAffiliateId.bind(this)}
            errorMessage={this.applyErrorToSelect("affiliate")}
          />
        }
      </div>
    );
  }

  applyErrorToSelect(orgType) {
    const errorMessage = this.props.virtualLineMover.errors.destinationError;

    if (errorMessage && ((orgType === "advertiser" && !this.destinationCampaign.requiresAffiliate()) || orgType === "affiliate")) {
      return errorMessage;
    }
  }

  updateAdvertiserCampaignId(event) {
    this.props.virtualLineMover.updateDestination({
      advertiserCampaignId: event.id
    });

    this.updateDestination(this.props.virtualLineMover.destinationCampaign);
  }

  updateAffiliateId(event) {
    this.props.virtualLineMover.updateDestination({
      affiliateCampaignId: event.id,
      advertiserCampaignId: this.destinationCampaign.advertiserCampaignId
    });

    this.updateDestination(this.props.virtualLineMover.destinationCampaign);
  }

  updateDestination(destinationCampaign) {
    this.destinationCampaign = destinationCampaign;
    this.props.updateListener(this.props.virtualLineMover);
  }
}

DestinationSelect.propTypes = {
  virtualLineMover:         PropTypes.object,
  updateListener:           PropTypes.func
};
